import { useParams } from 'react-router';

export const usePharmacyId = () => {
  const { pharmacyId } = useParams();

  if (!pharmacyId) {
    throw new Error('usePharmacyId must be used under a /:pharmacyId route');
  }

  return pharmacyId;
};
